import React from 'react';
import { analytics } from '../Core/AnalyticsManager';

export default class LobbyFeaturedContentPanel extends React.Component
{
  render()
  {
    return (
      <>
        <div className="lobby-featured-content-panel-title">FEATURED CONTENT</div>

        <div className="lobby-featured-content-panel-content-container">

          <div className="lobby-featured-content-panel-content-row"
            onClick={ () =>
            {
              analytics.track( 'featuredContent_1' );
              window.open( 'https://youtu.be/eecKGlkccWg?si=qET8I1zLNjfcH2Tp', '_blank' ).focus();
            } }>
            <img className="lobby-featured-content-panel-content-row-thumbnail" src={ process.env.PUBLIC_URL + '/featured-content/carcassonne-world-championship-2021_carcassonnecat.png' } alt="Carcassonne World Championship 2021 video thumbnail" />
            <img className="lobby-featured-content-panel-content-row-video-play-icon" src={ process.env.PUBLIC_URL + '/ui/play-video-icon.png' } alt="Play Video Icon" />
            <div className="lobby-featured-content-panel-content-row-title">Carcassonne World Championship 2021</div>
            <div className="lobby-featured-content-panel-content-row-content">Maciej Polak vs Melvin Quaresma - 16/10/21</div>
            <div className="lobby-featured-content-panel-content-row-author">Carcassonnecat</div>
          </div>

          <div className="lobby-featured-content-panel-content-row"
            onClick={ () =>
            {
              analytics.track( 'featuredContent_2' );
              window.open( 'https://youtu.be/R1qh-lhxy9s?si=NnHgSdxPUtguwDwd', '_blank' ).focus();
            } }>
            <img className="lobby-featured-content-panel-content-row-thumbnail" src={ process.env.PUBLIC_URL + '/featured-content/carcassonne-how-to-play_watchitplayed.png' } alt="Carcassonne How To Play video thumbnail" />
            <img className="lobby-featured-content-panel-content-row-video-play-icon" src={ process.env.PUBLIC_URL + '/ui/play-video-icon.png' } alt="Play Video Icon" />
            <div className="lobby-featured-content-panel-content-row-title">Carcassonne - How To Play</div>
            <div className="lobby-featured-content-panel-content-row-content">Learn how to play Carcassonne!</div>
            <div className="lobby-featured-content-panel-content-row-author">Watch It Played</div>
          </div>

          <div className="lobby-featured-content-panel-content-row"
            onClick={ () =>
            {
              analytics.track( 'featuredContent_3' );
              window.open( 'https://youtu.be/BlGk0g4uSKk?si=RWBpxDnYGGkfGDxg', '_blank' ).focus();
            } }>
            <img className="lobby-featured-content-panel-content-row-thumbnail" src={ process.env.PUBLIC_URL + '/featured-content/strategy-from-champion_boardgameoftears.png' } alt="Strategy of Champions video thumbnail" />
            <img className="lobby-featured-content-panel-content-row-video-play-icon" src={ process.env.PUBLIC_URL + '/ui/play-video-icon.png' } alt="Play Video Icon" />
            <div className="lobby-featured-content-panel-content-row-title">Strategies from a Champion</div>
            <div className="lobby-featured-content-panel-content-row-content">Hear from Rebecca Beach, winner of the World Series of Board Games.</div>
            <div className="lobby-featured-content-panel-content-row-author">Board Game of Tears</div>
          </div>

          <div className="lobby-featured-content-panel-content-row"
            onClick={ () =>
            {
              analytics.track( 'featuredContent_4' );
              window.open( 'https://youtu.be/Nuvskmdq0f8?si=8IGfEGjq699LzPk0', '_blank' ).focus();
            } }>
            <img className="lobby-featured-content-panel-content-row-thumbnail" src={ process.env.PUBLIC_URL + '/featured-content/level-up-your-carcassonne_tabletopdungeon.png' } alt="Strategy of Champions video thumbnail" />
            <img className="lobby-featured-content-panel-content-row-video-play-icon" src={ process.env.PUBLIC_URL + '/ui/play-video-icon.png' } alt="Play Video Icon" />
            <div className="lobby-featured-content-panel-content-row-title">Level Up Your Carcassonne</div>
            <div className="lobby-featured-content-panel-content-row-content">Three top winning strategies for cutthroat Carcassonne.</div>
            <div className="lobby-featured-content-panel-content-row-author">Tabletop Dungeon</div>
          </div>

        </div>
      </>
    );
  }
};
